module.exports = "/shifts/components/inviteEmployeesTrigger-92bceb.html";